import { Button, formatDate, Column, Hint, Label, Textarea, useLoading } from "best-common-react";
import React from "react";
import { sendSuiteConfirmationEmailTicketReminder } from "../../../api/RequesTixApi";
import { SuiteStatuses } from "../../../types/SuiteRequest";
import { AdminSuiteActionsProps } from "./AdminSuiteRequestsActions";

const AdminSuiteEmailConfirmation = ({
  request,
  actionState,
  setActionState,
  saveRequest,
  refreshRequest,
}: AdminSuiteActionsProps) => {
  const { setLoading } = useLoading();

  const sendConfirmationEmail = async () => {
    try {
      setLoading(true);
      await saveRequest(request, actionState);
      setTimeout(async () => {
        await sendSuiteConfirmationEmailTicketReminder(request.suiteRequestId!);
        void refreshRequest();
      }, 100);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const canSendEmail = () => {
    switch (request.suiteRequestStatus?.suiteStatusId!) {
      case SuiteStatuses.DENIED:
        return true;
      case SuiteStatuses.APPROVED:
        return !!actionState.selectedGamePk;
      case SuiteStatuses.CANCELLED:
        return true;
      default:
        return false;
    }
  };

  return (
    <>
      <Column width={1}>
        <Textarea
          id="confirmation-email-notes"
          label="Confirmation Email Notes"
          value={actionState.confirmationEmailNotes}
          onChange={(value: string) => {
            setActionState({
              ...actionState,
              confirmationEmailNotes: value,
            });
          }}
          gutterBottom
        />
      </Column>
      <Column width={2}>
        <Label htmlFor="send-confirmation-email">Confirmation Email</Label>
        <div className="d-flex align-items-center bcr-mb-2">
          <Button
            id="send-confirmation-email"
            variant="default"
            className="bcr-me-2"
            onClick={sendConfirmationEmail}
            disabled={!canSendEmail()}
          >
            Send Email
          </Button>
          <Hint>
            {actionState.confirmationEmailSentDate
              ? `Email sent: ${formatDate(new Date(actionState.confirmationEmailSentDate))}`
              : ""}
          </Hint>
        </div>
      </Column>
    </>
  );
};

export default AdminSuiteEmailConfirmation;
